import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles.css';
import { loginAdmin } from '../../redux/slices/adminAuthSlice';
import { verifyAccessToken, loginAsAdminFunc } from '../../redux/slices/protectSlice';
import bgSignin from '../../images/bg-signin.jpg';
import logo from '../../images/white_logo.png';
import eyeIcon from '../../images/eye.svg';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status } = useSelector((state) => state.adminAuth);

  const { isAuthenticated, userType } = useSelector((state) => state.protect);
  useEffect(() => {
    if (isAuthenticated == null || isAuthenticated === 'null') {
      dispatch(verifyAccessToken());
    }
    if (isAuthenticated && userType === 'admin') {
   

      var shouldHideDashboard = localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1";
      if (!shouldHideDashboard) {
        navigate('/admin/users');
      } else {
        navigate('/admin/dashboard');
      }

    }
    if (isAuthenticated && userType === 'client') {
      navigate('/meal-plan');
    }
  }, [isAuthenticated]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status !== 'loading') {
      setErrorMessage(null);
      setSuccessMessage('Trying to authenticate you, please wait...');
      const response = await dispatch(loginAdmin(formData));
      if (response.payload && response.payload.status === 'Success') {
        setErrorMessage(null);
        dispatch(loginAsAdminFunc());
      } else if (response.payload && response.payload.message) {
        setErrorMessage(response.payload.message);
        setSuccessMessage(null);
      } else {
        setErrorMessage('Unexpected error occurred. Please try again.');
        setSuccessMessage(null);
      }
    }
  };

  if (isAuthenticated === 'null' || isAuthenticated == null) {
    return false;
  }

  return (
    <div className="admin dashboard-container" id="app-body">
      <div
        className="bg-signin page-signin"
        style={{
          backgroundImage: `url(${bgSignin})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          height: '100vh'
        }}
      >
        <div
          className="main-body justify-between"
          style={{
            position: 'relative',
            zIndex: 2,
            background: 'rgba(255, 0, 0, 0.8)', // Red background with 80% opacity

            padding: '2rem',
            borderRadius: '8px',
            margin: 'auto',
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          <div className="form-body-container">
            <section id="form" className="form">
              <form method="POST" id="signForm" onSubmit={handleSubmit}>
                <div className="logo-signin text-center" style={{ marginBottom: '2rem' }}>
  <img 
    src={logo} 
    alt="logo" 
    style={{
      maxWidth: '100%',
      height: 'auto',
      maxHeight: '100px', // Adjust height to fit your design
      objectFit: 'contain'
    }} 
  />
</div>
                <div className="form-sigin-wrap">
                  <h3>Welcome to<br />Admin Dashboard</h3>
                  <p>Your go-to diet app for achieving your health and wellness goals.</p>

                  {successMessage && (
                    <div className="alert alert-success">{successMessage}</div>
                  )}
                  {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )}

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <div className="password-wrap">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        name="password"
                        required
                        placeholder="Password"
                        minLength="6"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                      />
                      <img
                        src={eyeIcon}
                        className="eye"
                        alt="toggle password visibility"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <button type="submit" className="btn btn-primary btn-block">Login</button>
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
